import React, { type FC } from "react";
import {
    BusinessBoStateValue,
    BusinessMeasureValue,
    BusinessStockObjValue,
    formatBusinessDateText,
} from "@src/components/business-data-display";
import { ListItem } from "@src/components/business-list";
import { BusinessList } from "@src/components/business-list";
import type { UseWsLimitCardLeavesQueryResult } from "../../hooks/useWsLimitCardLeavesQuery";

interface WsLeavesLimitCardListProps {
    leavesQuery: UseWsLimitCardLeavesQueryResult;
    onOpenLeave: (leaveCode: number) => void;
}

export const WsLeavesLimitCardList: FC<WsLeavesLimitCardListProps> = ({ leavesQuery, onOpenLeave }) => {
    const { leaves, isFetching } = leavesQuery;

    return (
        <BusinessList isLoad={isFetching}>
            {leaves.map((item) => (
                <ListItem
                    key={item.Code}
                    title={`Отпуск ${formatBusinessDateText(item.LeaveDate)}`}
                    props={[
                        { label: "Статус", value: <BusinessBoStateValue state={item.Bo?.State} labelSource="short" /> },
                        {
                            label: "Отпущено",
                            value: <BusinessMeasureValue value={item.Qty} measure={item.LimitCardContent?.MeasMain} />,
                        },
                        {
                            label: "Номенклатура",
                            value: <BusinessStockObjValue stockObj={item?.LimitCardContent?.StockObj} />,
                        },
                    ]}
                    onClick={() => {
                        onOpenLeave(item.Code);
                    }}
                />
            ))}
        </BusinessList>
    );
};
